import { Truck, Shield, Clock } from "lucide-react";

const items = [
  { icon: Truck, text: "Free UK Shipping 🇬🇧" },
  { icon: Shield, text: "30-Day Money-Back Guarantee" },
  { icon: Clock, text: "Limited Time: Up to 47% Off Bundles" },
];

const AnnouncementBar = () => (
  <div className="w-full gradient-primary text-white py-2.5 z-[60] relative overflow-hidden">
    {/* Desktop: static centered */}
    <div className="hidden sm:flex container mx-auto px-4 items-center justify-center gap-8 text-sm font-medium">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <item.icon size={14} className="shrink-0" />
          {item.text}
          {i < items.length - 1 && <span className="ml-8 w-px h-3.5 bg-white/30" />}
        </span>
      ))}
    </div>

    {/* Mobile: scrolling marquee */}
    <div className="sm:hidden flex">
      <div className="animate-marquee flex shrink-0 items-center gap-6 text-xs font-medium whitespace-nowrap">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-1.5 px-2">
            <item.icon size={13} className="shrink-0" />
            {item.text}
            <span className="ml-4 text-white/40">✦</span>
          </span>
        ))}
      </div>
      <div className="animate-marquee flex shrink-0 items-center gap-6 text-xs font-medium whitespace-nowrap">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-1.5 px-2">
            <item.icon size={13} className="shrink-0" />
            {item.text}
            <span className="ml-4 text-white/40">✦</span>
          </span>
        ))}
      </div>
    </div>
  </div>
);

export default AnnouncementBar;
